const getters = {
  accountExpired(state) {
    return state.shopInfo.plan == "trial" && state.shopInfo.remainingDays <= 0;
  },
  displayLanguage(state) {
    if (state.hideLanguage) {
      return process.env.VUE_APP_I18N_LOCALE;
    }
    return state.shopInfo.language;
  },
  gethelpSystemSetting(state){
    return state.gethelp;
  },
  allLocales(state) {
    if (!state.language || !state.language.list.length) {
      return [];
    }
    return state.language.list.map(x => x.name);
  },
  languageSource(state) {
    if (!state.language || !state.language.list.length) {
      return {};
    }
    const output = {};
    state.language.list.forEach(lang => {
      output[lang.name] = lang.source;
    });
    return output;
  },
  accountFirstName(state) {
    if (!state.shopInfo) return false;
    return state.shopInfo.firstName;
  },
  shopifyDomain(state) {
    if (!state.shopInfo) return false;
    return state.shopInfo.shopifyDomain;
  },
  shopPlan(state) {
    if (!state.shopInfo) return false;
    return state.shopInfo.plan;
  },
  shopIsPro(state) {
    if (!state.shopInfo) return false
    return ["trial", "professional", "advanced"].includes(state.shopInfo.plan)
  },
  statusLoadingShopInfo(state) {
    return state.status.loading
  }
};

export default getters;
